// extracted by mini-css-extract-plugin
export default {"wrapper":"Referral_wrapper__-95E3","title":"Referral_title__TCSrl","boxes":"Referral_boxes__XCudM"};